// Basemap URLs with language support where possible
export const basemapOptions = {
    aesthetic: {
        url: () => `https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png`,
        attribution: '© OpenStreetMap contributors © CARTO'
    },
    standard: {
        url: () => `https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png`,
        attribution: '© OpenStreetMap contributors'
    },
    satellite: {
        url: () => `https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}`,
        attribution: 'Tiles © Esri — Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
    },
    transit: {
        url: () => `https://tile.memomaps.de/tilegen/{z}/{x}/{y}.png`,
        attribution: '© OpenStreetMap contributors, © MeMoMaps'
    }
};
